<template>
    <div class="faqs-window" @click.self="closeFaqs">
        <div class="faqs-window--inner">

            <div class="close-buyer" @click="closeFaqs"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path></svg></div>

            <h2>Faqs</h2>

            <a href="https://www.cartafutbol.com/instrucciones/" target="_blank"><button class="button2">instrucciones</button></a>

            <div class="faqs-wrapper">

                <div class="faq-question" v-for="faq in faqs">
                    <div class="faq-question--question" @click="faq.show = !faq.show" v-html="faq.question" :class="{opened : faq.show}">
                    </div>
                    <div class="faq-question--answer" v-show="faq.show" v-html="faq.answer">
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            faqs: [
                {
                question:  '¿Como funciona Carta Futbol?',
                answer:  'Con nuestro “Creador” puedes componer tu carta. Elegir tu nombre, dorsal, posición en el campo, valores de jugador.Seleccionar una de tus imágenes y ajustarla. Quitarle el fondo para que sólo tu destaques en la imagen, ponerte borde, reposicionarla, cambiarla a gris o sepia o ajustar la luminosidad, contraste o saturación.  El siguiente paso será modificar los colores de la carta en sí para ajustarlos a tu gusto o los de tu equipo. Si lo prefieres, podrás elegir nuestros estilos predefinidos incluidos en el desplegable.  Por último, podrás subir el escudo de tu equipo. Una vez seleccionado todo estarás listo para generar y descargar tu carta. Recuerda revisarla bien ya que una vez generada no admitirá más cambios. ',
                show: false
                },
                {
                question:  '¿Por qué es necesario registrarse? ',
                answer:  'Para poder llevar cuenta de tu saldo de fichas personal y tener acceso a las cartas que hayas generado usando tu cuenta. ',
                show: false
                },
                {
                question:  '¿Puedo borrar mi cuenta o cartas?',
                answer:  'Por supuesto, debajo de cada carta tienes la opción de borrarla. También puedes borrar tu cuenta entera desde el menú de sesión. Ten en cuenta que al borrar toda la cuenta también desaparecerán las cartas del menú y el saldo de fichas que tuvieras aún disponible. Todas las cartas ya descargadas seguirán en tu dispositivo. ',
                show: false
            },
                {
                question:  '¿Cómo puedo ampliar mi foto o reposicionarla?',
                answer:  'Accede al menú de imagen y podrás hacer zoom, moverla o cambiarle la tonalidad, saturación, contraste. ',
                show: false
            },
                {
                question:  '¿Por qué la aplicación no ha eliminado el fondo de mi foto? ',
                answer:  'El tamaño ha excedido el máximo o tu foto tiene demasiados elementos (la aplicación no podrá distinguir cual es el principal y cual el fondo). Recórtala un poco para eliminar “intrusos”.',
                show: false
            },
                {
                question:  '¿Para qué sirven los ajustes personalizados?',
                answer:  'Cambia los colores del fondo y los elementos de la carta. Ajústalos a tu gusto o a los colores de tu equipo. Podrás guardar el estilo para usarlo en más de una Carta sin tener que volver a seleccionar todo.Una vez guardado el estilo tan solo tendrás que seleccionarlo en el menú desplegable para que te aplique los colores elegidos. ',
                show: false
            },
                {
                question:  '¿Puedo cambiar el tamaño del escudo?',
                answer:  'Selecciónalo y estíralo o encógelo usando las bolitas amarillas que hay en cada esquina de la imagen. ',
                show: false
            },
                {   
            question:  '¿Por qué está el logo de CartaFutbol en mi Carta?',
                answer:  'Nuestro logo aparecerá en la visión previa de tu tarjeta. Una vez que generes la Carta con tu diseño definitivo el logo desaparecerá para la descarga final. ',
                show: false
            },
                {
                question:  '¿Puedo hacer cambios en mi tarjeta?',
                answer:  'Antes de generarla puedes ajustar todos los valores y cambiarlos cuantas veces sea necesario. Una vez generada no se podrá cambiar. ',
                show: false
            },
                {
                question:  '¿Qué formato tienen las Cartas?',
                answer:  'Tu descarga final será en formato PNG. Perfecto para mantener la calidad de la imagen y que puedas compartir la Carta en tus redes sociales, enviarla o incluso imprimirla. ',
                show: false
            },
                {
                question:  '¿Cuántas veces puedo descargar mi Carta?',
                answer:  'Una vez que generas tu Carta se descargará automáticamente y pasará a formar parte de tu galería “Mis Cartas” a la que podrás acceder desde tu menú de sesión. Ahí estará disponible para que la descargues tantas veces quieras. Si así lo deseas podrás borrarla usando el icono de papelera debajo de ella. ',
                show: false
            },
                {
                question:  '¿Cuánto cuesta cada Carta?',
                answer:  'Crear una Carta te costará una ficha de tu saldo. Puedes comprarlas desde tu menú de inicio o usando el botón “Fichas” que se encuentra arriba a la derecha de la página principal del creador de Cartas. Hay diferentes planes de precios en función de la cantidad de fichas compradas. ',
                show: false
            },
                {
                question:  '¿Caducan las fichas?',
                answer:  'No tienen caducidad y seguirán almacenadas en tu cuenta hasta que decidas usarlas para tus creaciones. ',
                show: false
            },
                {
                question:  '¿Son reembolsables las fichas?',
                answer:  'Al ser productos digitales no se ofrecen reembolsos. ',
                show: false
                }
            ]

        }
    },
    methods: {
        closeFaqs() {
            console.log('close')
            this.$emit('closeFaqs')
        }
    }
}
</script>

<style lang="less">
    .faqs-window {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        background: var(--overlay_bg);
        padding: 3rem 1rem 1rem;
        z-index: 1000;
        overflow: auto;

        .faqs-window--inner {
            background: white;
            padding: 3rem 2rem 3rem;
            width: 100%;
            max-width: 850px;
            border-radius: var(--radius_global);
            box-shadow: var(--modal_boxshadow);
            margin: auto;
            position: relative;
        }
    }

    .faq-question--question {
        cursor: pointer;
        font-weight: 600;
        padding: 1.5rem 1.5rem 1.5rem 1rem;
        position: relative;
        background: #f1f1f1;
        border-radius: var(--radius_global);
        margin-bottom: 1rem;
        line-height: 1;

        &::after {
            content: '+';
            right: 0.5rem;
            top: 50%;
            transform: translateY(-50%);
            position: absolute;
        }

        &.opened::after {
            content: '-'
        }
    }
    .faq-question--answer {
        padding: 0rem 1rem 2rem;
        font-size: 0.85rem;
    }

    .faqs-wrapper {
        margin-top: 2rem;
    }

</style>